// extracted by mini-css-extract-plugin
export default {"loader":"loader__KYc8-","spin":"spin__TqONf","light":"light__D9y13","wrapper":"wrapper__0PtG2"};